// Recovery decision for a lazy route chunk that failed to load.
//
// The overwhelmingly common cause is a stale SPA: a deploy replaced the
// content-hashed chunk filenames the loaded document was built against,
// so the URL its bundle asks for no longer exists. One full reload of
// the (already-updated) URL fixes it. But a reload that ALWAYS fires
// would loop forever when the chunk is unreachable for a reason a
// reload can't fix — offline, or a genuinely broken build — so the
// attempt is remembered per target href.
//
// Pure so the loop guard is testable without a router or a live page:
// an infinite reload loop is the one failure here that's worse than
// the bug it fixes.
export type ChunkRecovery = 'reload' | 'report';

export function decideChunkRecovery(lastTriedHref: string, href: string): ChunkRecovery {
	// Same target already reloaded once and still failed → don't loop.
	return lastTriedHref === href ? 'report' : 'reload';
}
